<div class="container mt-5">
  <div class="mb-4">
    <h2 class="text-center">
      <span translate>PUNCHOUT_ORDER_PLACED</span>
    </h2>
    <p class="text-center" *ngIf="orderId">
      <span translate>ORDER_ID</span>:
      {{ orderId }}
    </p>
  </div>
</div>
